import React from "react";

export const ContactCardComponent = (props) => {
    let image
    try {
        image = require("../../../../public/images/profiles/" + props.imageName)
    } catch (e) {
        image = require("../../../../public/images/unknown.png")
    }
    return (
        <div className="contact-box" style={{height: '200px'}}>
            <div className="row d-flex align-items-center h-100">
                <img src={image} alt="profile" className='col-4 align-self-center rounded-circle img-fluid'/>
                <div className="col-8 text-left pl-5 align-self-center">
                    <h3>
                        <strong>{props.name}</strong>
                    </h3>
                    <h4>
                        {props.title}
                    </h4>
                    <h5>FCSE, UKIM, Skopje</h5>
                </div>
            </div>
        </div>
    )
}
